import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { Modal } from "bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import * as caseService from "../../Services/caseService";
import { toast } from "react-toastify";

const B2CBulkStatusChanges = forwardRef((props, ref) => {
  const { selectedCases, setSelectedCases, getCaseData } = props;
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });
  const modalRef = useRef(null);
  const bsModal = useRef(null);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [caseStatusTypeOptions, setCaseStatusTypeOptions] = useState([]);

  const handleClose = () => {
    reset();
    bsModal.current?.hide();
  };

  useImperativeHandle(ref, () => ({
    // toggle(caseIds) {

    //     // Single case
    //     if (caseIds !== undefined && caseIds !== null) {

    //         if (Array.isArray(caseIds)) {
    //             setSelectedCases(caseIds);
    //         } else {
    //             setSelectedCases([Number(caseIds)]);
    //         }
    //     }

    //     if (!bsModal.current) {
    //         bsModal.current = new Modal(modalRef.current);
    //     }

    //     bsModal.current.show();
    // },

    toggle(caseIds) {
      if (caseIds !== undefined && caseIds !== null) {
        let ids = [];

        if (Array.isArray(caseIds)) {
          ids = caseIds;
        } else {
          ids = [Number(caseIds)];
        }

        setSelectedCases(ids);

        // Single case ke liye next status lao
        if (ids.length === 1) {
          getNextCaseStatuses(ids[0]);
        }
      }

      if (!bsModal.current) {
        bsModal.current = new Modal(modalRef.current);
      }

      bsModal.current.show();
    },

    close() {
      handleClose();
    },
  }));

  // useEffect(() => {
  //     getNextCaseStatuses();
  // }, [])

  // const getcaseStatus = () => {
  //     caseService.casestatus()
  //         .then((res) => {
  //             const data = res?.data?.data || [];
  //             const formattedOptions =
  //                 data.map((item) => ({
  //                     label: item?.name?.trim(),
  //                     value: item?.id,
  //                 }));

  //             setCaseStatusTypeOptions(
  //                 formattedOptions
  //             );

  //         }).catch((error) => {

  //         })
  // }

  const getNextCaseStatuses = async (caseId) => {
    if (!caseId) {
      return;
    }

    try {
      const res = await caseService.getNextCaseStatuses(caseId);

      const data = res?.data?.data || [];

      const formattedOptions = data.map((item) => ({
        label: item?.name?.trim(),
        value: item?.id,
      }));

      setCaseStatusTypeOptions(formattedOptions);
    } catch (error) {
      setCaseStatusTypeOptions([]);

      toast.error(
        error?.response?.data?.message || "Failed to get next statuses",
      );
    }
  };

  const onSubmit = async (data) => {
    try {
      setSubmitLoader(true);

      const payload = {
        // caseId: selectedCases,
        caseId: selectedCases.join(","),
        status: data.status?.label,
        // status: data.status
      };

      const res = await caseService.b2cstatuschanges(payload);

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message || "Status changed successfully.");

        setSelectedCases([]);

        // Parent ka API refresh
        if (props.getCaseData) {
          props.getCaseData();
        }

        handleClose();
      } else {
        toast.error(res?.data?.message || "Status change failed.");
      }
    } catch (error) {
      // console.log("Status Change Error:", error);

      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Something went wrong while changing status.",
      );
    } finally {
      setSubmitLoader(false);
    }
  };
  return (
    <div
      className="modal fade"
      ref={modalRef}
      tabIndex="-1"
      aria-hidden="true"
      style={{ background: "rgba(15,23,42,0.55)", backdropFilter: "blur(5px)" }}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered "
        style={{ maxWidth: "95vw", width: "95vw", margin: "10px auto" }}
      >
        <div
          className="modal-content border-0 rounded-4"
          style={{ width: "100%" }}
        >
          <div
            className="modal-header border-0 text-white"
            style={{ background: "linear-gradient(135deg,#2563eb,#1d4ed8)" }}
          >
            <div className="">
              <p className="mb-0 small opacity-75">Bulk Status Changes</p>
            </div>
            <button
              className="btn btn-light rounded-circle position-absolute"
              type="button"
              style={{
                top: "10px",
                right: "18px",
                width: "38px",
                height: "38px",
              }}
              onClick={handleClose}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-body p-4">
              <div className="row g-4">
                <div className="col-md-12">
                  <label className="form-label fw-semibold">
                    Status
                    <span className="text-danger ms-1">*</span>
                  </label>

                  <Controller
                    name="status"
                    control={control}
                    rules={{
                      required: "Please select atleast one status",
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        classNamePrefix="react-select"
                        options={caseStatusTypeOptions}
                        placeholder="Select"
                        isSearchable
                        isClearable
                        value={field.value || null}
                      />
                    )}
                  />

                  {errors.status && (
                    <small className="text-danger fw-semibold">
                      {errors.status.message}
                    </small>
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer border-0 px-4 pb-4">
              <button
                className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                type="button"
                onClick={handleClose}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                disabled={submitLoader}
              >
                {submitLoader ? "Updating..." : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
});

export default B2CBulkStatusChanges;
